import { useStaticQuery, graphql } from "gatsby";

import { Query } from "@graphql-types";

const FooterQuery = (iban: string) => {
  const { allSanityFooter }: Query = useStaticQuery(graphql`
    query FooterQuery {
      allSanityFooter {
        nodes {
          showSocialMedia
          links {
            _key
            links {
              ...sanityLink
            }
            navTitle
            _type
            _key
          }
          bottomItems {
            ...sanityLink
          }
          logo {
            ...sanityFullWidthImage
          }
          region {
            iban
          }
        }
      }
    }
  `);

  if (allSanityFooter == null) return null;

  const filteredFooter = allSanityFooter.nodes.filter(footer => {
    if (footer.region == null) return null;
    if (footer.region.iban === iban) return footer;
    if (footer.region.iban === process.env.GATSBY_DEFAULT_IBAN_REGION) return footer;

    return null;
  });

  if (filteredFooter.length > 1) {
    return filteredFooter.find(footer => footer.region?.iban === iban);
  }

  return filteredFooter[0];
};

export default FooterQuery;
